module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isEditValid),
      callback: function($$v) {
        _vm.isEditValid = $$v
      },
      expression: "isEditValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Minimum Blinds:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Minimum Blinds",
      "type": "number",
      "required": "",
      "rules": _vm.minRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.globalModalParams.minimum),
      callback: function($$v) {
        _vm.$set(_vm.globalModalParams, "minimum", $$v)
      },
      expression: "globalModalParams.minimum"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Maximum Blinds:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Maximum Blinds",
      "type": "number",
      "required": "",
      "rules": _vm.maxRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.globalModalParams.maximum),
      callback: function($$v) {
        _vm.$set(_vm.globalModalParams, "maximum", $$v)
      },
      expression: "globalModalParams.maximum"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Total Price:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Total Price",
      "type": "number",
      "required": "",
      "rules": _vm.totalRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.globalModalParams.total),
      callback: function($$v) {
        _vm.$set(_vm.globalModalParams, "total", $$v)
      },
      expression: "globalModalParams.total"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.runAdd) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.isEditValid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncEditTier()
      }
    }
  }, [_vm._v("Update")]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}